import Vue from 'vue'
import Mobile from './Mobile'
import router from '@/router'
import store from '@/app/store'
import VueCompositionAPI from '@vue/composition-api'
import VueCookies from 'vue-cookies'
import i18n from '@/app/localization'
import Localizer from '@/plugins/localizationPlugin';
import PortalVue from 'portal-vue'

import './vee-validate/validate';

import '@/notifications/notification'

import '@/app/assets/scss/app.scss'

import '@/app/icons'

import {LicenseManager} from "ag-grid-enterprise";
LicenseManager.setLicenseKey('CompanyName=IT-Steiger.NET,LicensedApplication=StySoft K2,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-016615,ExpiryDate=18_June_2022_[v2]_MTY1NTUwNjgwMDAwMA==567c420f162fc10ea68d967268a17b54');

import Widget from "./components/widget/Widget";
import Modal from "./components/Modal";
import Grid from "./components/Grid";
import Form from "./components/Form/Form";
import FormInput from "./components/Form/FormInput";

import './filter/dateFilter';
import './filter/dateTime';
import './filter/digitFilter';
import './filter/pigletType';
import './filter/userFilter';

// import '@/app/style'
import BootstrapVue from 'bootstrap-vue'

Vue.config.productionTip = false

Vue.use(VueCookies);
Vue.use(VueCompositionAPI)
Vue.use(BootstrapVue)
Vue.use(Localizer)
Vue.use(PortalVue)

Vue.component('sty-widget', Widget);
Vue.component('sty-modal', Modal);
Vue.component('sty-grid', Grid);
Vue.component('sty-form', Form);
Vue.component('sty-form-input', FormInput);

window.useRouter = () => router
window.useStore = () => store
window.useCookies = () => Vue.prototype.$cookies
window.useI18n = () => ({ t: Vue.prototype.$t, tc: Vue.prototype.$tc })

window.isCordova = () => window.hasOwnProperty('cordova') && window.cordova.platformId !== 'browser'

if (window.isCordova()) {
  document.addEventListener('deviceready', () => {
    document.addEventListener('online', () => store.commit('APP_ONLINE', true))
    document.addEventListener('offline', () => store.commit('APP_ONLINE', false))
  })
} else {
  window.addEventListener('online', () => store.commit('APP_ONLINE', true))
  window.addEventListener('offline', () => store.commit('APP_ONLINE', false))
}

store.dispatch('APP_INIT')

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then(registration => {
      console.log('SW registered: ', registration);
    }).catch(registrationError => {
      console.log('SW registration failed: ', registrationError);
    });
  })
} else {
  console.log('no service worker support');
}

new Vue({
  el: '#app',
  router,
  i18n,
  store,
  template: '<Mobile/>',
  components: {
    Mobile
  }
});
